// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useNavigate } from '@tanstack/react-router';

// material ui
// React import not required for new JSX transform
import {
  Alert,
  Box,
  Card,
  CircularProgress,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

// relative
import useDashboardsFromServices from './utils/useDashboardsFromServices';

const DashboardPage = () => {
  const { dashboards, isLoading, isFetching, error } =
    useDashboardsFromServices();
  const { t } = useTranslation('dashboards-common');

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate({ to: path });
  };

  return (
    <Box sx={{ width: '100%', mt: 4 }}>
      <Typography variant="h5" mb={1}>
        {t('title')}
      </Typography>

      {isLoading || isFetching ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{t('failedToLoadAccount')}</Typography>
      ) : dashboards.length > 0 ? (
        <Card>
          <List>
            {dashboards.map((d) => (
              <ListItemButton
                key={d.id}
                onClick={() => handleNavigate(d.path)}
                disabled={!d.isReady}
              >
                {d.icon && <ListItemIcon>{d.icon}</ListItemIcon>}
                <ListItemText
                  primary={d.title}
                  secondary={
                    d.isReady ? d.description : t('dashboardCards.notReady')
                  }
                />
              </ListItemButton>
            ))}
          </List>
        </Card>
      ) : (
        <Alert severity="info">{t('noDashboards')}</Alert>
      )}
    </Box>
  );
};

export default DashboardPage;
